import { render, staticRenderFns } from "./StreamHealthWidget.vue?vue&type=template&id=03800870&scoped=true"
import script from "./StreamHealthWidget.vue?vue&type=script&lang=js"
export * from "./StreamHealthWidget.vue?vue&type=script&lang=js"
import style0 from "./StreamHealthWidget.vue?vue&type=style&index=0&id=03800870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03800870",
  null
  
)

export default component.exports